export const INIT = 'APP/INIT';
export const init = () => ({ type: INIT });
